let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9HY4f")).then(() => parcelRequire('gt5sN'));